export const
    vp_amount = require('./vp_amount.svg'),
    vp_effortless = require('./vp_effortless.svg'),
    vp_price = require('./vp_price.svg'),
    vp_skip = require('./vp_skip.svg')